var React = require('react');

function List (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#3899EC","fillRule":"nonzero","d":"M0 3c0-1.657 1.337-3 3.01-3h9.98A3.005 3.005 0 0 1 16 3v9c0 1.657-1.337 3-3.01 3H3.01A3.005 3.005 0 0 1 0 12V3zm1 .003v8.994C1 13.107 1.898 14 3.006 14h9.988A2.004 2.004 0 0 0 15 11.997V3.003C15 1.893 14.102 1 12.994 1H3.006A2.004 2.004 0 0 0 1 3.003zM5 4h8v1H5V4zm0 3h8v1H5V7zm0 3h8v1H5v-1zM3 4h1v1H3V4zm0 3h1v1H3V7zm0 3h1v1H3v-1z"}));
}

List.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15"};

module.exports = List;

List.default = List;
